export type StoredSession = {
  roomCode: string;
  playerId: string;
  playerToken: string;
  name: string;
};

export const SESSION_STORAGE_KEY = 'river-zero.session';

export const loadStoredSession = (): StoredSession | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  // Versions before tab-scoped sessions stored one identity for the whole origin.
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
  const raw = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as StoredSession;
  } catch {
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
    return null;
  }
};

export const persistStoredSession = (session: StoredSession) => {
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
  window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
};

export const clearStoredSession = () => {
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
  window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
};
